import React from 'react';
import {
  Dialog,
  AppBar,
  Toolbar,
  makeStyles,
  Theme,
  Typography,
  IconButton,
  Grid,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { colors } from 'design-system';
import { XCircle } from 'react-feather';

type Props = {
  open: boolean;
  onCloseRequested: () => void;
  title: string;
  fullScreenOnMobile?: boolean;
  children?: React.ReactNode;
};

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    backgroundColor: colors.madison,
    [theme.breakpoints.down('sm')]: {
      backgroundColor: (useFullScreen: boolean): string => {
        return useFullScreen ? colors.white : colors.madison;
      },
    },
  },
  dynamicTextColor: {
    color: colors.white,
    [theme.breakpoints.down('sm')]: {
      color: (useFullScreen: boolean): string => {
        return useFullScreen ? colors.madison : colors.white;
      },
    },
  },
  appBarOffset: theme.mixins.toolbar,
  closeIcon: {
    position: 'absolute',
    top: '50%',
    marginTop: -12,
    right: theme.spacing(2),
  },
  contentWrapping: {
    padding: theme.spacing(2),
  },
  paddedText: {
    display: 'inline-block',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    fontSize: 16,
  },
  dialoguePaper: {
    background: '#f9f9f9',
    position: 'relative',
    borderRadius: 10,
    [theme.breakpoints.down('sm')]: {
      borderRadius: (useFullScreen: boolean): number =>
        useFullScreen ? 0 : 10,
    },
  },
}));

const InstructionsDialogue = ({
  open,
  onCloseRequested,
  title,
  children,
  fullScreenOnMobile = false,
}: Props): JSX.Element => {
  const classes = useStyles(fullScreenOnMobile);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      fullScreen={isMobile && fullScreenOnMobile}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className: classes.dialoguePaper,
      }}
      onClose={onCloseRequested}
    >
      <AppBar position="absolute" className={classes.appBar} elevation={0}>
        <Toolbar>
          <Grid container justifyContent="center">
            <Typography variant="body1" className={classes.dynamicTextColor}>
              {title}
            </Typography>
          </Grid>
        </Toolbar>
        <IconButton
          data-testid="close-button"
          className={classes.closeIcon}
          onClick={onCloseRequested}
        >
          <XCircle className={classes.dynamicTextColor} />
        </IconButton>
      </AppBar>

      <div className={classes.appBarOffset} />
      <div className={classes.contentWrapping}>{children}</div>
    </Dialog>
  );
};

export default InstructionsDialogue;
